import { FC } from 'react';
import { useParams } from 'react-router';
import styled from 'styled-components';
import logo from '../assets/restore-logo.svg';

const Container = styled.div(({ theme }) => {
  const { color, type } = theme.new;

  return `
    font-family: ${type.face};
    background-color: ${color.shade[2]};
    height: 100vh;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;

    h1 {
      font-size: ${type.size[22]};
      font-weight: ${type.weight.bold};
      margin-bottom: 1.5rem;
    }

    p {
      margin-bottom: 1rem;
    }

    a {
      color: ${color.brand[1].dark};
    }
  `;
});

const Block = styled.div(({ theme }) => {
  const { color } = theme.new;

  return `
    max-width: 500px;
    background-color: ${color.shade[1]};
    padding: 2rem;
    border-radius: 16px;
  `;
});

const LogoContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;

  img {
    max-width: 350px;
  }
`;

const KeycloakRedirect: FC = () => {
  const { realm } = useParams<{ realm: string }>();
  const url = `${import.meta.env.VITE_LOGIN_PROTOCOL}://${realm}-${import.meta.env.VITE_LOGIN_URL}`;

  return (
    <Container>
      <Block>
        <LogoContainer>
          <img alt="Restore Logo" src={logo} />
        </LogoContainer>
        <h1>Your login has moved!</h1>
        <p>
          We've improved site security! Please log in at the new URL: <a href={url}>{url}</a>
        </p>

        <p>This change ensures a safer experience. Please remember to update your bookmarks.</p>
      </Block>
    </Container>
  );
};

export default KeycloakRedirect;
